export default __webpack_public_path__ + "static/media/Screenshot (1122).59d6473a.png";